<template>
  <div class="right-cont">
    <div class="page-name help-detail-top">隐私政策</div>
    <div class="help-detail-right" v-html="content"></div>
  </div>
</template>

<script>
import { getListByTypeCode } from "@/http/user_center";

export default {
  name: "Privacy",
  data() {
    return {
      content: "",
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      getListByTypeCode({type_code: 'yinsizhengce'}).then((res) => {
        this.content = res.data.yinsizhengce
      });
    },
  },
};
</script>


<style scoped src="../../assets/css/user_center.css"></style>
